import React, {Component} from 'react';
import {TopButtonAction, TopButtonAdd} from "../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../componentsTopsa/if/TopIf";
import PropTypes from 'prop-types';

/*
*
*   Komponent odpowiada za wyświetlanie przycisku do dodawania nowego rekordu do bazy oraz przycisku włączającego filtry (wyszukiwanie)
*
* */

export default class KonfiguracjaHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <div>
                <div className={'pull-right'}>
                    <TopIf isTrue={this.props.pokazButtonSzukaj}>
                        <TopButtonAction onClick={this.props.pokazWyszukiwarke} text={(this.props.czySzukanieWlaczone)?'Ukryj wyszukiwanie':'Pokaż wyszukiwanie'} iconType={'fa fa-search'}/>
                    </TopIf>
                    <span style={{width:'5px', display:"inline-block"}}></span>
                    <TopButtonAdd onClick={this.props.pokazFormularz} text={this.props.tekstDodaj} buttonSize={'small'}/>
                </div>
                <div style={{clear:'both',height:'1px'}}></div>
            </div>
        );
    }
}

KonfiguracjaHeader.propTypes = {
    pokazFormularz: PropTypes.func.isRequired,
    tekstDodaj: PropTypes.string,
    pokazWyszukiwarke: PropTypes.func,
    pokazButtonSzukaj: PropTypes.bool,
    czySzukanieWlaczone: PropTypes.bool,

};

KonfiguracjaHeader.defaultProps = {
    pokazButtonSzukaj: true,
    tekstDodaj: 'Dodaj',
    czySzukanieWlaczone: false,
};



// WEBPACK FOOTER //
// ./src/shared/headers/KonfiguracjaHeader.js